var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#D80027;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c141.4,0,256-114.6,256-256c0-31.3-5.6-61.3-15.9-89H15.9C5.6,194.7,0,224.7,0,256 C0,397.4,114.6,512,256,512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,512c110.1,0,203.9-69.5,240.1-167H15.9C52.1,442.5,145.9,512,256,512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,144.7v127.7c0,72.6,94.9,94.9,94.9,94.9S256,345,256,272.4V144.7L66.2,144.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.5,144.7v127.7c0,8.5,1.9,16.6,5.6,24.1h134c3.8-7.5,5.6-15.6,5.6-24.1V144.7L88.5,144.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.6,233.7h-33.4v-22.3h22.3v-22.3h-22.3V167H150v22.3h-22.3v22.3H150v22.3h-33.4V256H150v22.3h22.3V256h33.4 V233.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.5,327.6c14.3,9,29.1,14.2,36.6,16.6c7.5-2.3,22.3-7.6,36.6-16.6c14.5-9.1,24.6-19.5,30.4-31.1 c-6.4-4.5-14.1-7.1-22.5-7.1c-3,0-6,0.4-8.9,1c-6-13.7-19.7-23.3-35.7-23.3s-29.6,9.6-35.7,23.3c-2.8-0.7-5.8-1-8.9-1 c-8.4,0-16.1,2.6-22.5,7.1C99.9,308.1,110,318.5,124.5,327.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.160a14b05e30ebbbab9c785499ac60ca.svg";
export { ForwardRef as ReactComponent };